// Default (editable via Admin CMS) content for Dr. Sangeeta Roy's profile.
// Placeholders in [brackets] are clearly marked editable fields.
export const defaultContent = {
  doctor: {
    name: "Dr. Sangeeta Roy",
    specialty: "Pharmacology",
    institution: "SGRR Medical College and Hospital",
    location: "Dehradun, Uttarakhand, India",
  },
  contact: {
    phone: "+91 86384 83218",
    whatsapp: "+91 86384 83218",
    email: "drsangeeta.roy1991@gmail.com",
    address: "[Clinic Address] — SGRR Medical College and Hospital, Dehradun, Uttarakhand",
    hours: "[Consultation Hours]",
  },
  hero: {
    eyebrow: "Pharmacology · Dehradun",
    headline: "Trusted Medical Care with a Patient-Centered Approach",
    sub: "Dr. Sangeeta Roy is associated with the Department of Pharmacology at SGRR Medical College and Hospital in Dehradun, focused on evidence-informed medical knowledge, clear communication and patient well-being.",
  },
  about: {
    intro:
      "Dr. Sangeeta Roy is associated with the Department of Pharmacology at SGRR Medical College and Hospital in Dehradun. Her work is built around clear communication, careful attention and a considered, evidence-informed approach to medicine.",
    approach:
      "The focus is on understanding each patient's concerns fully, explaining conditions in plain language, and guiding patients toward informed decisions about their health.",
    fields: {
      qualification: "[Medical Qualification]",
      experience: "[Years of Experience]",
      memberships: "[Professional Memberships]",
      expertise: "[Areas of Clinical Expertise]",
      languages: "[Languages Spoken]",
    },
  },
};

// Deep-ish merge for two-level content object
export function mergeContent(base, override) {
  if (!override) return base;
  const out = { ...base };
  for (const k of Object.keys(override)) {
    if (override[k] && typeof override[k] === "object" && !Array.isArray(override[k])) {
      out[k] = { ...(base[k] || {}), ...override[k] };
      for (const j of Object.keys(override[k])) {
        if (override[k][j] && typeof override[k][j] === "object") {
          out[k][j] = { ...((base[k] || {})[j] || {}), ...override[k][j] };
        }
      }
    } else {
      out[k] = override[k];
    }
  }
  return out;
}
